module.exports = __webpack_public_path__ + "static/pic07-56d0f8f2cc816b068b3d5670ccdd3939.jpg";